import Grid from '@mui/material/Grid';

import DailySalesManagerChart from './chart-component';
import DailySalesManagerTable from './table-component';

const DailySalesManagerContent = (props) => {
  return (
    <Grid item size={{ xs: 12 }}>
      <Grid container mt={7}>
        <Grid item size={{ xs: 12, md: 12 }}>
          <DailySalesManagerChart props={props} />
        </Grid>
        <Grid item size={{ xs: 12, md: 12 }}>
          <DailySalesManagerTable props={props} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DailySalesManagerContent;
